import React, { useState, useEffect, useCallback, useRef } from "react";
import api from "../../../api/api";
import ItemPopUp from "./ItemPopUp";
import Swal from "sweetalert2";
import PaymentHistory from "./PaymentHistory";
import { FaHistory } from "react-icons/fa";
import TripBadgeDownloader from "./TripBadgeDownloader";


import {
  Table,
  Input,
  Button,
  Space,
  Drawer,
  Typography,
} from "antd";

import {
  SearchOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

/* ===================== DEBOUNCE ===================== */
const useDebounce = (value, delay = 500) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
};

const GoodsItemList = () => {
  const API_URL = "/manage-shipments/";

  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchTracking, setSearchTracking] = useState("");

  const debouncedCustomer = useDebounce(searchCustomer);
  const debouncedTracking = useDebounce(searchTracking);

  const [page, setPage] = useState(1);

  /* ================= POPUP ================= */
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedShipment, setSelectedShipment] = useState(null);

   /* ================= PAYMENT-HISTORU-POPUP ================= */
  const [openHistory, setOpenHistory] = useState(false);
 

  /* ================= EDIT ================= */
  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  /* ================= LOAD ================= */
  const buildURL = useCallback(() => {
    let url = `${API_URL}?page=${page}`;
    if (debouncedCustomer) url += `&search=${debouncedCustomer}`;
    if (debouncedTracking) url += `&search=${debouncedTracking}`;
    return url;
  }, [page, debouncedCustomer, debouncedTracking]);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(buildURL());
      setShipments(res.data.results || []);
    } catch {
      Swal.fire("Error", "Failed to load shipments", "error");
    } finally {
      setLoading(false);
    }
  }, [buildURL]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    setPage(1);
  }, [debouncedCustomer, debouncedTracking]);

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    const res = await Swal.fire({
      title: "Delete shipment?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete",
    });

    if (!res.isConfirmed) return;

    try {
      await api.delete(`${API_URL}${id}/`);
      Swal.fire("Deleted", "Shipment removed", "success");
      loadData();
    } catch {
      Swal.fire("Error", "Delete failed", "error");
    }
  };

  /* ================= EDIT OPEN ================= */
  const openEdit = (record) => {
    setEditData(record);
    setEditOpen(true);

    // backend image preview
    setImagePreview(record.goods_image || null);
  };

  /* ================= SAVE EDIT ================= */
  /* ================= SAVE EDIT ================= */
const saveEdit = async () => {
  try {
    const formData = new FormData();

    formData.append("customer_name", editData.customer_name || "");
    formData.append("receiver_name", editData.receiver_name || "");
    formData.append("amount_charge", editData.amount_charge || "");
    formData.append("amount_paid", editData.amount_paid || 0);
    formData.append("discount", editData.discount || 0);
    formData.append("items_name", editData.items_name || "");

    if (editData.goods_image instanceof File) {
      formData.append("goods_image", editData.goods_image);
    }

    await api.patch(`${API_URL}${editData.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    Swal.fire("Success", "Shipment updated successfully.", "success");

    setEditOpen(false);

    loadData();

    // update popup if editing the opened shipment
    if (selectedShipment && selectedShipment.id === editData.id) {
      setSelectedShipment({
        ...selectedShipment,
        ...editData,
      });
    }

  } catch (err) {
    Swal.fire(
      "Error",
      err?.response?.data?.detail || "Update failed.",
      "error"
    );
  }
};
  /* ================= TABLE ================= */
 /* ================= TABLE ================= */
const columns = [
  {
    title: "#",
    render: (_, __, index) => index + 1,
    width: 60,
  },

  {
    title: "Customer",
    dataIndex: "customer_name",
  },

  {
    title: "Trip",
    dataIndex: "trip_name",
  },

  {
    title: "Receiver",
    dataIndex: "receiver_name",
  },

  {
    title: "Charge",
    render: (_, record) => (
      <b style={{ color: "#1677ff" }}>
        ${Number(record.amount_charge).toLocaleString()}
      </b>
    ),
  },

  {
    title: "Amount Paid",
    render: (_, record) => (
      <span
        style={{
          color: "#0b8f2f",
          fontWeight: 700,
        }}
      >
        ${Number(record.amount_paid || 0).toLocaleString()}
      </span>
    ),
  },

  {
    title: "Balance",
    render: (_, record) => (
      <span
        style={{
          color:
            Number(record.balance) > 0
              ? "#d4380d"
              : "#389e0d",
          fontWeight: 700,
        }}
      >
        ${Number(record.balance || 0).toLocaleString()}
      </span>
    ),
  },

{
  title: "Actions",
  dataIndex: "actions",
  key: "actions",

  // ✅ IMPORTANT FIX
  fixed: "right",
  width: 220,

  render: (_, record) => (
    <Space size="small" style={{ whiteSpace: "nowrap" }}>
      <button
        onClick={() => {
          setSelectedShipment(record);
          setOpenHistory(true);
        }}
        style={{
          background: "#111827",
          color: "#fff",
          border: "none",
          padding: "6px 10px",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        <FaHistory />
      </button>

      <Button
        icon={<EyeOutlined />}
        onClick={() => {
          setSelectedShipment(record);
          setPopupOpen(true);
        }}
      />

      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={() => openEdit(record)}
      />

      <Button
        danger
        icon={<DeleteOutlined />}
        onClick={() => handleDelete(record.id)}
      />
    </Space>
  ),
}


];

  /* ================= UI ================= */
  return (
    <div style={{ padding: 20 }}>

      
      <div style={{ display: "flex", justifyContent: "center" }}>
  <Title
    level={3}
    style={{
      backgroundColor: "#FFE5B4",
      padding: "6px 14px",
      borderRadius: "10px",
      margin: 0
    }}
  >
    Goods Shipments
  </Title>
</div>

<br/>

      {/* SEARCH */}
      <Space style={{ marginBottom: 15 }}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search customer"
          value={searchCustomer}
          onChange={(e) => setSearchCustomer(e.target.value)}
          style={{ width: 250 }}
        />

        <Input
          prefix={<SearchOutlined />}
          placeholder="Tracking code"
          value={searchTracking}
          onChange={(e) => setSearchTracking(e.target.value)}
          style={{ width: 250 }}
        />
      </Space>

      <div>
        <TripBadgeDownloader/>
      </div>

      <br/> <br/>

      {/* TABLE */}

<div style={{ width: "100%" }}>
  <Table
    dataSource={shipments}
    columns={columns}
    rowKey="id"
    loading={loading}
    pagination={{
      pageSize: 10,
      onChange: (p) => setPage(p),
    }}

    // ✅ FIX: allow full width instead of cutting buttons
    scroll={{ x: "max-content" }}
    sticky
  />
</div>

      {/* POPUP */}
<ItemPopUp
  open={popupOpen}
  shipment={selectedShipment}
  onClose={() => setPopupOpen(false)}
  onRefresh={loadData}
  onShipmentUpdated={(shipment) => {
    setSelectedShipment(shipment);

    setShipments((prev) =>
      prev.map((item) =>
        item.id === shipment.id ? shipment : item
      )
    );
  }}
/>

{/* PAYMENT HISTORY MODAL */}
<PaymentHistory
  open={openHistory}
  shipment={selectedShipment}
  onClose={() => setOpenHistory(false)}
/>

      {/* EDIT DRAWER */}
      <Drawer
        title="Edit Shipment"
        open={editOpen}
        onClose={() => setEditOpen(false)}
        width={450}
      >
        {editData && (
          <Space direction="vertical" style={{ width: "100%" }}>

            <Input
              value={editData.customer_name}
              onChange={(e) =>
                setEditData({ ...editData, customer_name: e.target.value })
              }
              placeholder="Customer name"
            />

            <Input
              value={editData.receiver_name}
              onChange={(e) =>
                setEditData({ ...editData, receiver_name: e.target.value })
              }
              placeholder="Receiver name"
            />

            <Input
              value={editData.amount_charge}
              onChange={(e) =>
                setEditData({ ...editData, amount_charge: e.target.value })
              }
              placeholder="Charge"
            />

            <Input
  value={editData.amount_paid}
  placeholder="Amount Paid"
  onChange={(e) =>
    setEditData({
      ...editData,
      amount_paid: e.target.value,
    })
  }
/>

            {/* ITEMS */}
            <Input.TextArea
              value={editData.items_name}
              onChange={(e) =>
                setEditData({ ...editData, items_name: e.target.value })
              }
              placeholder="Items"
              rows={3}
            />

            {/* IMAGE UPLOAD */}
            <div style={{ marginTop: 10 }}>
              <label style={{ fontWeight: 600 }}>Goods Image</label>

              {/* PREVIEW (SAFE FIX) */}
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "100%",
                    borderRadius: 10,
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                />
              )}

              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  setEditData({
                    ...editData,
                    goods_image: file,
                  });

                  setImagePreview(URL.createObjectURL(file));
                }}
              />

              <div
  style={{
    background: "#fff8e6",
    padding: 12,
    borderRadius: 8,
    fontWeight: 700,
    color: "#d46b08",
    textAlign: "center",
  }}
>
  Balance: ${Number(editData.balance || 0).toLocaleString()}
</div>

              <Button
                block
                style={{
                  background: "linear-gradient(135deg, #ff8a00, #ff5e00)",
                  color: "#fff",
                  border: "none",
                  fontWeight: 600,
                }}
                onClick={() => fileInputRef.current?.click()}
              >
                📦 Upload Goods Image
              </Button>
            </div>

            <Button type="primary" block onClick={saveEdit}>
              Save Changes
            </Button>

          </Space>
        )}
      </Drawer>

    </div>
  );
};

export default GoodsItemList;

